import { styled } from 'styled-components';

export const ScheduleTable = styled.div`
  thead {
    tr {
      th {
        height: 3rem;
        color: ${({ theme }) => theme.colours.ink.primary.main};
      }
    }
  }

  tbody {
    tr {
      height: 3rem;

      td {
        color: ${({ theme }) => theme.colours.ink.primary.main};
      }
      // not the first two, but all others
      td:nth-child(n + 4) {
        font-weight: ${({ theme }) => theme.typography.headingSmall.fontWeight};
      }
    }
  }
`;
ScheduleTable.displayName = 'ScheduleTable';

export const GameResult = styled.span`
  display: flex;
  gap: ${({ theme }) => theme.sizing.small};
  align-items: center;
  font-size: ${({ theme }) => theme.typography.bodySmall.fontSize};
  font-weight: ${({ theme }) => theme.typography.headingSmall.fontWeight};
`;
GameResult.displayName = 'GameResult';
